import { render, staticRenderFns } from "./addUser.vue?vue&type=template&id=35caec58&scoped=true"
import script from "./addUser.vue?vue&type=script&lang=js"
export * from "./addUser.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/user/addUser.css?vue&type=style&index=0&id=35caec58&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35caec58",
  null
  
)

export default component.exports